// @vendors
import React, { useContext } from "react";

// @components
import {
  Button,
  FormControl,
  InputLabel,
  NativeSelect,
  useGridApiContext,
} from "../../../../components/shared/MaterialUI.js";
import { DataTable } from "../../Admin";

export const CustomFiltering = () => {
  const {
    getAllCompanies,
    rowsState,
    setRowsState,
  } = useContext(DataTable);
  const apiRef = useGridApiContext();

  const onSelectChange = (e) => {
    e.preventDefault();
    const selectedValue = e.target.value;
    setRowsState((current) => ({
      ...current,
      filters: {...current.filters, status: selectedValue}
    }));
    const filters = {name: rowsState?.filters.name, status:selectedValue}
    const params = { filters: filters}
    getAllCompanies(params);
    apiRef.current.hideFilterPanel();
  };

  const clearFilters = () => {
    setRowsState((current) => ({
      ...current,
      filters: {name:'', status: ''}
    }));
    getAllCompanies({ filters: {}});
    apiRef.current.hideFilterPanel();
  };

  return (
    <>
      <FormControl fullWidth className={"statusSelect"}>
        <InputLabel variant="standard" className={"selectLabel"}>
          Company status
        </InputLabel>
        <NativeSelect
          defaultValue={rowsState?.filters.status ?? "status"}
          onChange={(e) => onSelectChange(e)}
        >
          <option name="status" hidden>
            Status
          </option>
          <option value={"active"}>Active</option>
          <option value={"suspended"}>Suspended</option>
          <option value={"inactive"}>Inactive</option>
        </NativeSelect>
      </FormControl>
      <Button onClick={() => clearFilters()}>Clear filter</Button>
    </>
  );
};
